import { CartsState } from '../CartsState';
import { RootState } from '../../RootState';

const selectCurrentCartPageActions = (state: RootState): CartsState['pageActions'] => {
  return state.carts.pageActions;
};

export default selectCurrentCartPageActions;
